import AtendimentosAoCliente from "../Atendimentos";

export default function AtendimentoGrupo() {
    return <AtendimentosAoCliente atendimento="GRUPO" />;
}
